import { Component } from '@angular/core';
import { provideTranslations } from '@app/shared/utils/translations-util';
import { GcTextComponent, IpoTranslatePipe } from '@ip-only/front-end-library';
import { getCurrentPortalCommunicationOperator } from '../../utils/communication-operator.util';
import en from '../strings.en.json';
import fi from '../strings.fi.json';
import sv from '../strings.sv.json';
import { FooterLinkComponent } from './footer-link/footer-link.component';
import { FOOTER_CONFIG } from './footer.config';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [IpoTranslatePipe, GcTextComponent, FooterLinkComponent],
  providers: [provideTranslations({ sv, en, fi })],
})
export class FooterComponent {
  readonly currentYear = new Date().getFullYear();

  readonly footer = FOOTER_CONFIG[getCurrentPortalCommunicationOperator()];

  readonly logoSrc =
    'https://assets.globalconnect.net/images/logos/gc-svg/horizontal/gc-logo-hor-white.svg';

  groupHeadingId(titleKey: string): string {
    return `footer-group-${titleKey.replace(/\./g, '-')}`;
  }
}
